export default __webpack_public_path__ + "static/media/05_o_preview_2.20ee25e3.jpg";